import React from 'react';
import { Formik, Form, Field } from 'formik';

import styles from './userSavedSearchesPageStyles';

import Button, { BUTTON_TYPES, BUTTON_SIZES } from 'buyside/components/presentation/Button/button';
import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';

const AlertName = ({
  editOpenIds,
  alert,
  initialValues,
  closeEditBox,
  handleUpdateSearchAlert
}) => {
  if (editOpenIds.includes(alert.id)) {
    return (
      <Formik
        initialValues={initialValues}
        onSubmit={values => handleUpdateSearchAlert(values, alert)}
      >
        {({ values, isSubmitting }) => {
          return (
            <Form>
              <div className={styles.editNameArea}>
                <div>
                  <Field
                    component={InputField}
                    name="name"
                    value={values.name}
                    customStyles={styles}
                  />
                </div>
                <div className={styles.buttonArea}>
                  <Button
                    type={BUTTON_TYPES.PRIMARY}
                    text="Save"
                    size={BUTTON_SIZES.SMALL}
                    isLoading={isSubmitting}
                  />
                  <Button
                    type={BUTTON_TYPES.SECONDARY}
                    text="Cancel"
                    size={BUTTON_SIZES.SMALL}
                    buttonType={BUTTON_TYPES.BUTTON}
                    onClick={closeEditBox}
                  />
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    );
  } else {
    return <h3>{alert.name}</h3>;
  }
};

export default AlertName;
